
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { useState } from 'react';
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";

import './css/tabs.css';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import { myData } from "../dbconnector/connector";
import Moment from 'moment';
import {
    getverlofaanvragenvoorwerknemer, saveverlofaanvraag, updateHolidayRequest
} from "../dbconnector/connector";
import "react-datepicker/dist/react-datepicker.css";
import { RotatingLines } from "react-loader-spinner";



const MyholidayRequest = (props) => {
    const t = props.translation
    const [requests, setRequests] = useState({});
    const [requestsarray, setRequestsarray] = useState([]);
    const data = myData();
    const [user, setUser] = useState({});
    const [holidayrequest, setrecord] = useState([]);
    const prevCSS = React.useRef(0)
    const prevSelectedRecord = React.useRef(0)
    const [isDisabled, setIsdisabled] = useState(true);
    const [isNewRecord, setIsNewRecord] = useState(true);
    const [isSaveRecord, setIsSaveRecord] = useState(true);
    const [isUpdateRecord, setIsUpdateRecord] = useState(true);
    const [isCancelRecord, setIsCancelRecord] = useState(true);
    const [isEditRecord, setIsEditRecord] = useState(true);


    useEffect(() => {
        document.getElementById("FullScreen_HolidayRequest").style.display = "none";

        setUser(props.user)
        dissableAll(true)
        setIsNewRecord(false)
        if (props.user) {
            LoadRequests(props.user.id)
        }
    }, [props.user]);

    const dissableAll = (value) => {
        setIsNewRecord(value)
        setIsSaveRecord(value)
        setIsUpdateRecord(value)
        setIsCancelRecord(value)
        setIsEditRecord(value)
    }
    const LoadRequests = (id) => {
        console.log("userid : ", id)
        setRequests([]);
        getverlofaanvragenvoorwerknemer(id).then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setRequests(body)
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    useEffect(() => {
        setRequestsarray([])
        try {
            if (requests.length > 0) {
                requests.forEach((item, index) => {
                    let cssname = "requested"
                    if (item.status === 0) {
                        cssname = "requested"
                    } else if (item.status === 1) {
                        cssname = "requested"
                        //cssname = "approvedsup"
                    } else if (item.status === 2) {
                        cssname = "approved"
                    }
                    else {
                        cssname = "rejected"
                    }
                    setRequestsarray(pre => [...pre,
                    <div id={item.id} className={index % 2 === 0 ? "linkVarient1Holiday_shortlist" : "linkVarient2Holiday_shortlist"} onClick={() => selectRecord(item)} >
                        <p disabled={true}>{Moment(item.startdatum).format('DD-MMM-YY')}</p>
                        <p disabled={true}>{Moment(item.einddatum).format('DD-MMM-YY')}</p>
                        <p disabled={true} className={cssname}>{item.status > 1 ? document.getElementById("status" + item.status).innerText : t("underrevision")}</p>
                    </div>
                    ])
                })
            } else {
                document.getElementById("EditButton").disabled = true;
            }
        } catch (error) {
            setErrorMessage(error.message)
        }
    }, [requests]);

    useEffect(() => {
        data.then(res => {
            try {
                if (document.getElementById("IconCleaning") !== null)
                    document.getElementById("IconCleaning").style.display = "none";
                if (document.getElementById("IconMyData") !== null)
                    document.getElementById("IconMyData").style.display = "none";
                if (document.getElementById("IconMyHoliday") !== null)
                    document.getElementById("IconMyHoliday").style.display = "block";
                if (document.getElementById("IconMyContract") !== null)
                    document.getElementById("IconMyContract").style.display = "none";
                setUser({ ...res })
            } catch (e) {
                setErrorMessage(t("error_retreivingData"))
            }
        })
    }, []);

    function selectRecord(record) {
        setrecord({})
        if (prevCSS.current !== undefined && prevSelectedRecord.current !== undefined) {
            if (document.getElementById(prevSelectedRecord.current)) {
                document.getElementById(prevSelectedRecord.current).className = prevCSS.current;
            }
        }
        prevCSS.current = document.getElementById(record.id).className;
        prevSelectedRecord.current = record.id
        document.getElementById(record.id).className = "selectedHolidayRow_shortlist"
        setrecord(record)
        dissableAll(true)
        setIsNewRecord(false)
        setIsEditRecord(false)
        setIsCancelRecord(false)
        if (record.status > 0) {
            setIsEditRecord(true)
            setIsSaveRecord(true)
        }
    }

    const handleOnchange = (e) => {
        setrecord(pre => ({ ...pre, [e.target.name]: e.target.value }))
    }

    const handleOnchangedate = (e) => {
        let einddatum = new Date(holidayrequest.einddatum);
        let startdatum = new Date(holidayrequest.startdatum);
        setrecord(pre => ({ ...pre, [e.target.name]: Moment(e.target.value).format('yyyy-MM-DD') }))
        if (e.target.name === "einddatum") {
            einddatum = new Date(e.target.value);
        }
        if (e.target.name === "startdatum") {
            startdatum = new Date(e.target.value);
        }

        if (checkdate(startdatum, einddatum)) {
            setErrorMessage(t("error_start-enddate"))
            document.getElementById("saveButton").disabled = true;
        } else {
            document.getElementById("saveButton").disabled = false;
        }

    }

    function checkdate(time1, time2) {
        return new Date(time1) > new Date(time2); // true if time1 is later
    }

    const ClearRecord = async () => {
        let statusvar = "0";
        setrecord(pre => ({ ...pre, id: undefined, typeaanvraag: "0", werknemers_Id: user.id, startdatum: Moment(new Date()).format('yyyy-MM-DD'), einddatum: Moment(new Date()).format('yyyy-MM-DD'), reden: undefined, status: statusvar, reden_afkeur: undefined, approved_by: undefined, approvaldate: undefined }))
    }

    const handlNewRecord = async () => {
        console.log("handlNewRecord")
        ClearRecord();
        setIsdisabled(false);
        dissableAll(true)
        //setIsNewRecord(true);
        setIsSaveRecord(false)
        setIsCancelRecord(false)

        document.getElementById("EditButton").style.display = "none"
        document.getElementById("saveButton").style.display = "block"
        document.getElementById("updateButton").style.display = "none"
    }

    const handlUpdateRecord = async () => {
        console.log("handlUpdateRecord")
        updateHolidayRequest(holidayrequest.id, holidayrequest).then(res => {
            if (res.status !== 200) {
                setErrorMessage(res.statusText);
            }
            else {
                ClearRecord();
                setIsdisabled(true)
                dissableAll(true)
                setIsNewRecord(false)
                setMessage("Uw verlofaanvraag is aangepast en doorgestuurd ter goedkeuring");
                document.getElementById("EditButton").style.display = "block"
                document.getElementById("saveButton").style.display = "none"
                document.getElementById("updateButton").style.display = "none"
            }
        })
        LoadRequests(props.user.id)
    }

    const handlEditRecord = async () => {
        console.log("handlEditRecord")
        setIsdisabled(false)
        dissableAll(true)
        setIsUpdateRecord(false)
        setIsCancelRecord(false)
        document.getElementById("EditButton").style.display = "none"
        document.getElementById("saveButton").style.display = "none"
        document.getElementById("updateButton").style.display = "block"
    }

    const handlCancelRecord = async () => {
        console.log("handlCancelRecord")
        ClearRecord();
        setIsdisabled(true)
        dissableAll(true)
        setIsNewRecord(false)
        // document.getElementById("EditButton").disabled = true;
        document.getElementById("EditButton").style.display = "block"
        document.getElementById("saveButton").style.display = "none"
        document.getElementById("updateButton").style.display = "none"
        LoadRequests(props.user.id)
    }

    const handleSave = () => {
        document.getElementById("FullScreen_HolidayRequest").style.display = "Block";
        let statusvar = "0";
        if (props.rights === 3 || props.rights === 2) {
            statusvar = "1";
        }
        holidayrequest.status = statusvar
        saveverlofaanvraag(holidayrequest, user.id).then(res => {
            if (res.status !== 200) {
                setErrorMessage(res.statusText);
                document.getElementById("FullScreen_HolidayRequest").style.display = "none";
            } else {
                ClearRecord();
                setIsdisabled(true)
                dissableAll(true)
                setIsNewRecord(false)
                LoadRequests(props.user.id)
                setMessage("Uw verlofaanvraag is doorgestuurd ter goedkeuring");
                document.getElementById("CancelMessageButton").style.display = "none"
                document.getElementById("EditButton").style.display = "block"
                document.getElementById("saveButton").style.display = "none"
                document.getElementById("updateButton").style.display = "none"
                document.getElementById("FullScreen_HolidayRequest").style.display = "none";
            }
        })
       
    }

    return (
        <>
            <div className="fullscreen" id="FullScreen_HolidayRequest">
                <div id="requestHolidayBlocker" className="checkingatworkstatusmessage">
                    <center>
                        <RotatingLines
                            strokeColor="grey"
                            strokeWidth="5"
                            animationDuration="0.75"
                            visible={true} className="spinner"
                        />
                        <br></br>
                        <div id="checktext">Processing Holiday request, please wait!</div>
                    </center>
                </div>
            </div>
            <div id="main" className="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText"></div><br></br>
                            <center>
                                <div className='messageBoxes'>
                                    <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={clearMessage}>{t("OK")}</Button>
                                    <Button type="button" id="CancelMessageButton" className="OkCancel messageBoxAlignleft" onClick={clearMessage}>{t("Cancel")}</Button>
                                </div></center>
                        </div></div>

                </header>
                <div id="content">
                    <div id="hotelselection" className='HolidayListpanel'>
                        <div className="holidayheader_shortlist">
                            <p id="Hotel_ID">{t('Start')}</p><p id="Hotel_Name" >{t('Einde')}</p><p id="Linked">{t('Status')}</p>
                        </div>
                        <div className="listHeight">
                            <div id="hotelsList">
                                {requestsarray}
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <Accordion alwaysOpen defaultActiveKey={['0']}>
                        <Accordion.Item eventKey="0" className="HolidayRequest">
                            <Accordion.Header>{t('Newholidayrequest')}</Accordion.Header>
                            <Accordion.Body>
                                <form id="holidayrequestform" className="holidayrequestform">
                                    <div id="id" className="formElement" style={{ display: "none" }}>
                                        <label>{t('Id')}</label>
                                        <input type="text" id="start" name="id" className='datepicker' value={holidayrequest.id === undefined ? "" : holidayrequest.id} onChange={handleOnchange} disabled />
                                    </div>
                                    <div id="startdate" className="formElement" >
                                        <label>{t('Startdatum')}</label>
                                        <input type="date" id="start" name="startdatum" className='datepicker' min={Moment(new Date()).format('yyyy-MM-DD')} value={Moment(holidayrequest.startdatum).format('yyyy-MM-DD')} onChange={handleOnchangedate} disabled={isDisabled} />
                                    </div>
                                    <div id="endate" className="formElement" >
                                        <label>{t('Einddatum')}</label>
                                        <input type="date" id="end" name="einddatum" className='datepicker' min={Moment(holidayrequest.startdatum).format('yyyy-MM-DD')} value={Moment(holidayrequest.einddatum).format('yyyy-MM-DD')} onChange={handleOnchangedate} disabled={isDisabled}
                                        />
                                    </div>
                                    <div id="reason_div" className="formElement formElementDoubleHeight" >
                                        <label>{t('Redenaanvraag')}</label>
                                        <textarea id="Reason" name="reden" className="textareaReason" value={holidayrequest.reden !== undefined ? holidayrequest.reden : ""} onChange={handleOnchange} disabled={isDisabled}></textarea>
                                    </div>
                                    <div id="statisdiv" className="formElement" >
                                        <label>{t('Status')}</label>
                                        <select className='datepicker' defaultValue="0" id="status" name="status" value={holidayrequest.status} disabled={props.rights === 2 ? false : true}>
                                            <option value="0" id="status0">{t('requested')}</option>
                                            <option value="1" id="status1">{t('pre-approved')}</option>
                                            <option value="2" id="status2">{t('approved')}</option>
                                            <option value="3" id="status3">{t('rejected')}</option>
                                        </select>
                                    </div>
                                    <div style={holidayrequest.reden_afkeur !== undefined ? { display: "block" } : { display: "none" }}>
                                        <div id="rejectreason_div" className="formElement formElementDoubleHeight">
                                            <label>{t('Redenafkeur')}</label>
                                            <textarea id="Reason" name="reden_afkeur" className="textareaReason" value={holidayrequest.reden_afkeur !== undefined ? holidayrequest.reden_afkeur : ""} onChange={handleOnchange} disabled></textarea>
                                        </div>
                                    </div>
                                    <div id="saveDiv" className="three_Buttons doublegrid noBackgroundcolor">
                                        <Button id="NewButton" className="startAssignmentbutton" onClick={() => handlNewRecord()} disabled={isNewRecord} >{t('New')}</Button>
                                        <Button id="saveButton" className="startAssignmentbutton" onClick={() => handleSave()} disabled={isSaveRecord} style={{ display: "none" }}>{t('Save')}</Button>
                                        <Button id="EditButton" className="startAssignmentbutton" disabled={isEditRecord} onClick={() => handlEditRecord()} >{t('Edit')}</Button>
                                        <Button id="updateButton" className="startAssignmentbutton" style={isUpdateRecord === true ? { display: "none" } : { display: "block" }} onClick={() => handlUpdateRecord()} disabled={isUpdateRecord} >{t('Update')}</Button>
                                        <Button id="CancelButton" className="startAssignmentbutton" disabled={isCancelRecord} onClick={() => handlCancelRecord()}>{t('Cancel')}</Button>
                                    </div>
                                </ form>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>


                </div>
            </div>
        </>
    )

}

export default MyholidayRequest